var map = {
	"./Berserker.png": 2410,
	"./Commando.png": 6207,
	"./Demolitions.png": 9626,
	"./Firebug.png": 2040,
	"./Medic.png": 1100,
	"./Sharpshooter.png": 6035,
	"./Support.png": 2162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2321;